import Vue from 'vue'

const actions = {
    async GetById(_, id) {
        try {
            const result = await Vue.prototype.$vanKirkApi.get(`inspection-request/${id}`);
            return result.data;
        }
        catch (error) {
            return false;
        }
    },

    async List() {
        try {
            const result = await Vue.prototype.$vanKirkApi.get('inspection-request/list');
            return result.data.result || [];
        }
        catch (error) {
            return [];
        }
    },

    async CreateUpdate(_, item) {
        try {
            await Vue.prototype.$vanKirkApi.post('inspection-request/create-update', item);
            return {
                success: true,
                message: 'Request saved successfully'
            };
        }
        catch (error) {
            return {
                success: false,
                message: error.response?.data || String(error)
            };
        }
    },

    async UpdateStatus(_, item) {
        try {
            await Vue.prototype.$vanKirkApi.put(
                `inspection-request/update-status/${item.id}`,
                {
                    status: item.status,
                    description: item.reason
                }
            );

            return { success: true };
        }
        catch (error) {
            return {
                success: false,
                message: error.response?.data || String(error)
            };
        }
    },

    async ListStatus() {
        try {
            const result = await Vue.prototype.$vanKirkApi.get('inspection-request/list-status');
            return result.data.result || [];
        }
        catch (error) {
            return [];
        }
    }
};

export default {
    namespaced: true,
    state: {},
    actions
};
